import OfficialAccount from './Index.vue'

OfficialAccount.install = function(Vue) {
    Vue.component(OfficialAccount.name, OfficialAccount)
}

export default OfficialAccount
